import Vue from 'vue'
import Vuex from 'vuex'
import { region } from '@/config/region'
Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		token: '',
		platformCode: sessionStorage.getItem("platformCode") || "",
		htmlTitle: sessionStorage.getItem("htmlTitle") || "",
		sunshinePurchase: sessionStorage.getItem("htmlTitle") || false,
		corporateName: sessionStorage.getItem("corporateName") || "",
		designatedGuaranteeAgencys: JSON.parse(sessionStorage.getItem("designatedGuaranteeAgencys")) || {},
	},
	mutations: {
		SET_HTML_TITLE(state) {
			// 根据地区编码 设置需要展示的内容
			let platformCodeList = Object.keys(region)
			if (platformCodeList.includes(state.platformCode)) {
				platformCodeList.forEach(item => {
					if (item === state.platformCode) {
						state.htmlTitle = region[item]
						state.sunshinePurchase = true
						sessionStorage.setItem("htmlTitle", state.htmlTitle)
						sessionStorage.setItem("sunshinePurchase", true)
						// console.warn(`地区编号${state.platformCode}:阳光采购地区`);
					}
				})
			} else {
				state.htmlTitle = ""
				state.sunshinePurchase = false
				sessionStorage.setItem("htmlTitle", state.htmlTitle)
				sessionStorage.setItem("sunshinePurchase", false)
				// console.warn(`地区编号${state.platformCode}:非阳光采购地区`);
			}
		},
		SET_PLATFORM_CODE(state, platformCode) {
			// 存储地区编码
			sessionStorage.setItem("platformCode", platformCode)
			state.platformCode = platformCode
		},
		SET_CORPORATE_NAME(state, corporateName) {
			// 存储公司名称
			sessionStorage.setItem("corporateName", corporateName)
			state.corporateName = corporateName
		},
		SET_DESIGNATED_GUARANTEE_AGENCY(state, guaranteeAgencys) {
			if (guaranteeAgencys) {
				guaranteeAgencys = guaranteeAgencys.split(",")
			} else {
				guaranteeAgencys = []
			}
			// 判断是否指定担保机构
			const obj = {
				guaranteeAgencys,
				isDesignated: false
			}
			if (guaranteeAgencys.length) obj.isDesignated = true;
			sessionStorage.setItem("designatedGuaranteeAgencys", JSON.stringify(obj))
			state.designatedGuaranteeAgencys = obj;
		}

	},
	actions: {

	},
	getters: {
		getHtmlTitle(state) {
			return state.sunshinePurchase ? state.htmlTitle : '公航旅电子交易中心平台'
		},
		getSunshinePurchasee(state) {
			return state.sunshinePurchase
		},
		getCorporateName(state) {
			return state.corporateName
		},
		getDesignatedGuaranteeAgencys(state) {
			return state.designatedGuaranteeAgencys
		},
		getPlatformCode(state) {
			return state.platformCode
		}
	}
})
